module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-duplicate-eed3313471e94c501e0d46ad0eaa6271.svg";